export default __webpack_public_path__ + "static/media/PCIENPE.565c5ef3.svg";